import { render, staticRenderFns } from "./PermissionPath.vue?vue&type=template&id=37505d81&scoped=true&"
import script from "./PermissionPath.vue?vue&type=script&lang=js&"
export * from "./PermissionPath.vue?vue&type=script&lang=js&"
import style0 from "./PermissionPath.vue?vue&type=style&index=0&id=37505d81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37505d81",
  null
  
)

export default component.exports